import React from 'react';
import { Badge } from '@/components/ui/badge';

const STYLES = {
  pending: ['Pending', 'bg-red-100 text-red-700'],
  partially_paid: ['Partially Paid', 'bg-amber-100 text-amber-800'],
  fully_paid: ['Fully Paid', 'bg-emerald-100 text-emerald-800'],
};

export const fmtRs = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Always derived from current GRN value vs amount paid, so an edited GRN value never shows a stale status.
export const grnPayment = (grn) => {
  const value = Number(grn.grand_total_incl_gst || grn.grand_total || 0);
  const paid = Number(grn.amount_paid || 0);
  const status = paid <= 0.01 ? 'pending' : paid >= value - 0.01 ? 'fully_paid' : 'partially_paid';
  return { value, paid, outstanding: Math.max(value - paid, 0), status };
};

export const PaymentStatusBadge = ({ status, testId }) => {
  const [label, cls] = STYLES[status] || STYLES.pending;
  return <Badge className={`${cls} whitespace-nowrap`} data-testid={testId}>{label}</Badge>;
};
